<div>
  <div class="top" [class.gradient-top]="colors.primaryColor2" id="top">
    <div class="col-2-3 headline">
      <h1 *ngIf="!activeReception.partOfCollection" class="overline">{{ activeReception.overline }}</h1>
      <div class="backButtonWrapper" *ngIf="activeReception.partOfCollection">
        <button mat-icon-button routerLink="..">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="overline">{{ activeReception.overline }}</h1>
      </div>
      <h1>{{ activeReception.headline }}</h1>
      <p *ngIf="activeReception.text" [innerHTML]="activeReception.text | safeHTML"></p>
    </div>
    <div class="col-1-3 visual">
      <img [src]="activeReception.keyvisual | safe" />
    </div>
  </div>
  <div class="bottom">
    <div class="col-2-3" id="left">
      <div class="video card" *ngIf="app.eventId !== '606e283b1993395f8ec0887f'">
        <img *ngIf="activeReception.mainBannerType === MainBannerType.Image" [src]="activeReception.mainBannerContent | safe" />
        <div *ngIf="activeReception.mainBannerType === MainBannerType.Video" class="iframe-container">
          <iframe
            [src]="activeReception.mainBannerContent | safe"
            frameborder="0"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay 'none'; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div *ngIf="app.eventId === '606e283b1993395f8ec0887f'" class="video-custom card">
        <img *ngIf="activeReception.mainBannerType === MainBannerType.Image" [src]="activeReception.mainBannerContent | safe" />
        <div *ngIf="activeReception.mainBannerType === MainBannerType.Video" class="iframe-container">
          <iframe
            [src]="activeReception.mainBannerContent | safe"
            frameborder="0"
            width="100%"
            height="100%"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay 'none'; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="partners" *ngIf="activeReception.partners">
        <app-partners [partnersUrl]="activeReception.partners" [partnerLink]="activeReception.partnerLink"></app-partners>
      </div>
    </div>
    <div class="col-1-3" *ngIf="agenda && agenda.enabled && !activeReception.partOfCollection" id="right" style="max-height: inherit; padding-bottom: 20px;">
      <div class="agenda-wrapper card">
        <app-agenda></app-agenda>
      </div>
    </div>
  </div>
</div>
